import { BaseTariffCard } from './base-tariff-card';

export type { ITariffCardProps } from './tariff-card.types';

export const TariffCard = BaseTariffCard;

export default TariffCard;
